/* 🤖 this file was generated by svg-to-ts */
export const DfIconClock16: {
  name: 'clock-16';
  data: string;
} = {
  name: 'clock-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="m8.998 7.589 1.71 1.715a1 1 0 1 1-1.415 1.414L7.291 8.709a.997.997 0 0 1-.293-.707v-3a1 1 0 1 1 2 0zM8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm0-2A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"/></svg>`
};
